import { initContract } from '@ts-rest/core'
import { z } from 'zod'

import { makePaginatedResponse } from '~/api/helper'
import { GiftWithPurchaseCampaign, GiftWithPurchaseCampaignDetail } from './schemas'

export function createPromotionContract() {
    const c = initContract()

    return c.router({
        listGiftWithPurchaseCampaigns: {
            method: 'GET',
            path: '/users/:owner_pk/gift-with-purchase-campaigns/',
            pathParams: z.object({ owner_pk: z.coerce.number() }),
            query: z
                .object({ ordering: z.string(), status: z.string(), search: z.string() })
                .partial(),
            responses: {
                200: makePaginatedResponse(GiftWithPurchaseCampaign),
            },
        },
        getGiftWithPurchaseCampaign: {
            method: 'GET',
            path: '/promotions/gift-with-purchase-campaigns/:id/',
            pathParams: z.object({ id: z.number().int() }),
            validateResponseOnClient: true,
            responses: {
                200: GiftWithPurchaseCampaignDetail,
            },
        },
        createGiftWithPurchaseCampaign: {
            method: 'POST',
            path: '/promotions/gift-with-purchase-campaigns/create/',
            body: GiftWithPurchaseCampaignDetail,
            responses: {
                201: GiftWithPurchaseCampaignDetail,
            },
        },
        updateGiftWithPurchaseCampaign: {
            method: 'PATCH',
            path: '/promotions/gift-with-purchase-campaigns/:id/',
            pathParams: z.object({ id: z.number().int() }),
            body: GiftWithPurchaseCampaignDetail.partial(),
            responses: {
                200: GiftWithPurchaseCampaignDetail,
            },
        },
        deleteGiftWithPurchaseCampaign: {
            method: 'DELETE',
            path: '/promotions/gift-with-purchase-campaigns/:id/',
            pathParams: z.object({ id: z.number().int() }),
            body: z.never(),
            responses: {
                204: z.never(),
            },
        },
    })
}
